import { render, staticRenderFns } from "./AskPhysio.vue?vue&type=template&id=09a5bba8&scoped=true&"
import script from "./AskPhysio.vue?vue&type=script&lang=js&"
export * from "./AskPhysio.vue?vue&type=script&lang=js&"
import style0 from "./AskPhysio.vue?vue&type=style&index=0&id=09a5bba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a5bba8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/AskPhysio.vue
// module id = null
// module chunks = 